import React from 'react';

export const HowWeSolveSection: React.FC = () => {
  const timeline = [
    {
      week: 1,
      title: 'Foundation and Profit Analysis',
      description: 'Audit the business to understand the current financial health of the business',
      icon: 'ri-file-chart-line'
    },
    {
      week: 2,
      title: 'Cost Reduction Strategies',
      description: 'Implement cost reduction strategies to improve profitability',
      icon: 'ri-scissors-cut-line'
    },
    {
      week: 3,
      title: 'Marketing and Revenue Optimization',
      description: 'Increase product sales and Marketing efficiency',
      icon: 'ri-line-chart-line'
    },
    {
      week: 4,
      title: 'Cash Flow and Financing',
      description: 'Improve Cash Flow and Expense Management',
      icon: 'ri-exchange-dollar-line'
    },
    {
      week: 5,
      title: 'Systems, SOPs, and Technology',
      description: 'Implement systems and SOPs to improve efficiency',
      icon: 'ri-settings-3-line'
    },
    {
      week: 6,
      title: 'Budgeting and Forecasting',
      description: 'Establish budget and forecast systems to guide financial decision-making',
      icon: 'ri-calendar-check-line'
    }
  ];

  return (
    <section id="solutions" className="py-20 bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            How We Solve Your Financial Challenges
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Unlike traditional Fractional CFOs that lock you into lengthy 6-12 month contracts before you see any ROI, Ad Astra delivers measurable returns from Week 1. In just 6 weeks, you'll have a comprehensive financial strategy tailored specifically to your practice—with clear ROI at every stage. Your investment starts paying for itself immediately, not months down the road. That's the Ad Astra ROI difference.
          </p>
        </div>

        <div className="max-w-5xl mx-auto relative">
          {/* Timeline Line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-blue-600 via-purple-600 to-blue-600"></div>

          {/* Timeline Items */}
          <div className="space-y-12">
            {timeline.map((item, index) => (
              <div key={item.week} className="relative">
                {/* Timeline Dot */}
                <div className="absolute left-1/2 transform -translate-x-1/2 w-6 h-6 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full border-4 border-white shadow-lg z-10"></div>

                {/* Content Card - Alternating Sides */}
                <div className={`flex ${index % 2 === 0 ? 'justify-start pr-1/2' : 'justify-end pl-1/2'}`}>
                  <div className={`w-5/12 ${index % 2 === 0 ? 'pr-12' : 'pl-12'}`}>
                    <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow border-2 border-transparent hover:border-blue-200">
                      <div className="flex items-start space-x-4">
                        <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center flex-shrink-0">
                          <i className={`${item.icon} text-white text-2xl`}></i>
                        </div>
                        <div className="flex-1">
                          <div className="inline-block bg-gradient-to-r from-blue-600 to-purple-600 text-white px-3 py-1 rounded-full text-sm font-semibold mb-2">
                            Week {item.week}
                          </div>
                          <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                          <p className="text-gray-600">{item.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
